import { ACCENTS } from './RadialSectionNav';

/**
 * The phone's section nav: a row of jumps sat directly above the first row of the run.
 *
 * The counterpart to RadialSectionNav rather than a second copy of it — that one is
 * `hidden lg:block`, this one is `lg:hidden`. The wheel can't come down here: the whole
 * of it is a hover interaction, and it opens wider than a phone is.
 *
 * Sat in the flow rather than pinned, because the runs below have no headings of their
 * own — arriving at the top of the portfolio, this row is what says what is in it.
 *
 * Colours are inline rather than classes because they come from the palette as bare
 * "r,g,b": a class assembled from a variable is one Tailwind never sees in the source
 * and so never generates.
 *
 * @param sections     [{ name }] in page order
 * @param activeIndex  section the page is currently scrolled into
 * @param onSelect     (index) => void
 * @param accent       key into ACCENTS — the palette of the page it sits on
 */
export default function SectionNavBar({ sections = [], activeIndex = 0, onSelect, accent = 'blue' }) {
    const tone = ACCENTS[accent] ?? ACCENTS.blue;
    if (!sections.length) return null;

    return (
        <nav aria-label="Sections" className="lg:hidden mb-6">
            {/* Wraps rather than scrolling sideways — a row that runs off the edge hides
                the jumps it holds. */}
            <div className="flex flex-wrap gap-2">
                {sections.map((section, index) => {
                    const isActive = index === activeIndex;

                    return (
                        <button
                            key={section.name}
                            type="button"
                            onClick={() => onSelect?.(index)}
                            aria-current={isActive ? 'true' : undefined}
                            className="px-3 py-1.5 rounded-full border text-[0.7rem] uppercase tracking-[0.18em] transition-colors duration-200"
                            style={{
                                borderColor: isActive ? `rgba(${tone.bright}, 0.9)` : `rgba(${tone.base}, 0.4)`,
                                backgroundColor: isActive ? `rgba(${tone.base}, 0.18)` : 'transparent',
                                color: isActive ? `rgb(${tone.node})` : `rgba(${tone.bright}, 0.75)`,
                            }}
                        >
                            {section.name}
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
